export default {
  'dashboard.title': 'Sendcloud App',
  'dashboard.ms': 'Shopline seamlessly connects with Sendcloud, and you can use Sendcloud to deliver goods in shopline',
  'dashboard.key.title': 'Sendcloud key configuration',
  'dashboard.key.title.ms': 'Please configure your Sendcloud generated key',
  'dashboard.key.name.placeholder': 'Please enter name',
  'dashboard.key.name.publickey.placeholder': 'Please enter publice key',
  'dashboard.key.name.secretkey.placeholder': 'Please enter secret key',
  'dashboard.key.btn.save': 'Save',
  'dashboard.order.push.title': 'Order push configuration',
  'dashboard.order.push.title.ms': 'Push function switch, range configuration',
  'dashboard.order.push.realtime': 'Real-time push',
  'dashboard.order.push.range': 'Range push',
  'dashboard.order.push.btn': 'Submit',
  'dashboard.order.push.log.title': 'Push log',
  'dashboard.order.push.log.title.ms': 'Manage all pushed order records',
  'dashboard.order.push.log.title.order.ms': 'Order push log',
  'dashboard.order.push.log.title.order.btn': 'Go To',
  'dashboard.sendcloud.title.ms': 'Log in to your Sendcloud management background',
  'dashboard.key.name.msg': 'Please input your name',
  'dashboard.key.publickey.msg': 'Please input your publicKey',
  'dashboard.key.secretKey.msg': 'Please input your secretKey',
  'btn.save.message': 'Saved successfully',
  'help.doc.title': 'help document',
  'btn.range.push.message': 'Push successfully',
  'time.then.30.day': 'The selected date range cannot exceed 30 days',
  'select.range,date': 'Please select a date range',
  'orders.found.res': 'orders found',
  'dashboard.sendcloud.webhook.title': 'Sendcloud WebHook Url',
  'dashboard.sendcloud.webhook.ms': 'sendcloud shipping status writeback address',
  'dashboard.sendcloud.webhook.btn.text': 'Copy',
  'dashboard.sendcloud.webhook.btn.copy.info': 'copy successfully',
  'dashboard.sendcloud.api.version.title': 'Sendcloud API Version Selection',
  'dashboard.sendcloud.api.version.desc': 'Selecting the version of Sendcloud API',
  'dashboard.sendcloud.api.version.card.title': 'API version',
  'dashboard.sendcloud.api.version.card.integration.title': 'Sendcloud Integration',
  'dashboard.sendcloud.api.version.card.integration.info': 'Please select the integration'
}



// WEBPACK FOOTER //
// ./src/locales/lang/en-US/dashboard/config.js